module.exports = __webpack_public_path__ + "img/logo.4b02db69.png";